// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../../common/Components/Label.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let PropertyPrice = require("../../common/Property/PropertyPrice.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let WizardFormUtils = require("../wizard/WizardFormUtils.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentProjectSearchResultCard = require("./DevelopmentProjectSearchResultCard.bs.js");
let DevelopmentProjectSearchResultAgent = require("./DevelopmentProjectSearchResultAgent.bs.js");
let DevelopmentProjectSearchResultActions = require("./DevelopmentProjectSearchResultActions.bs.js");
let DevelopmentProjectSearchResultTimestamp = require("./DevelopmentProjectSearchResultTimestamp.bs.js");
let DevelopmentProjectSearchResultTitleAndLocation = require("./DevelopmentProjectSearchResultTitleAndLocation.bs.js");
let DevelopmentProjectSearchResult_developmentProject_graphql = require("../../../__generated__/DevelopmentProjectSearchResult_developmentProject_graphql.bs.js");

let convertFragment = DevelopmentProjectSearchResult_developmentProject_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentProjectSearchResult_developmentProject_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResult_developmentProject_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentProjectSearchResult_developmentProject_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentProjectSearchResult_developmentProject_graphql.node, convertFragment, fRef);
}

let ProjectFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentProjectSearchResult$StatusLabel(props) {
  return JsxRuntime.jsx(Label.Info.make, {
    text: "Development Project"
  });
}

let StatusLabel = {
  make: DevelopmentProjectSearchResult$StatusLabel
};

function DevelopmentProjectSearchResult(props) {
  let project = RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResult_developmentProject_graphql.node, convertFragment, props.project);
  let unitCount = Stdlib_Option.map(project.totalProjectUnits, totalProjectUnits => totalProjectUnits.toString() + ` ` + (
    totalProjectUnits === 1 ? "unit" : "units"
  ));
  let values = Stdlib_Array.keepSome([
    WizardFormUtils.noneIfEmpty(project.developer),
    unitCount,
    Stdlib_Option.map(project.estimatedCompletion, Scalars.Year.toString)
  ]);
  let summary = values.length !== 0 ? values.join(" • ") : undefined;
  let price = project.price;
  return JsxRuntime.jsx(DevelopmentProjectSearchResultCard.make, {
    project: project.fragmentRefs,
    label: JsxRuntime.jsx(DevelopmentProjectSearchResult$StatusLabel, {}),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(DevelopmentProjectSearchResultTitleAndLocation.make, {
          project: project.fragmentRefs
        }),
        price !== undefined ? JsxRuntime.jsx(PropertyPrice.PriceInternal.PriceDisplay.make, {
            propertyPrice: price.fragmentRefs,
            size: "medium"
          }) : JsxRuntime.jsx("div", {
            children: "Pricing not available",
            className: "text-lg font-medium text-gray-500"
          }),
        summary !== undefined ? JsxRuntime.jsx("div", {
            children: summary,
            className: "text-sm text-zinc-600"
          }) : null,
        JsxRuntime.jsx(DevelopmentProjectSearchResultAgent.make, {
          project: project.fragmentRefs
        }),
        JsxRuntime.jsx(DevelopmentProjectSearchResultTimestamp.make, {
          project: project.fragmentRefs
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(DevelopmentProjectSearchResultActions.make, {
            project: project.fragmentRefs
          }),
          className: "mt-auto"
        })
      ],
      className: "flex h-full flex-col gap-4"
    })
  });
}

let Card;

let TitleAndLocation;

let Agent;

let Timestamp;

let Actions;

let make = DevelopmentProjectSearchResult;

exports.ProjectFragment = ProjectFragment;
exports.StatusLabel = StatusLabel;
exports.Card = Card;
exports.TitleAndLocation = TitleAndLocation;
exports.Agent = Agent;
exports.Timestamp = Timestamp;
exports.Actions = Actions;
exports.make = make;
/* Label Not a pure module */
